import { Component, h } from 'preact';
import { TcrTags } from './tcr-tags';
import { AppState } from './app-state';
import { I } from 'intl';

class TcrTagInput extends Component
{
    constructor(props)
    {
        super(props);

        this.insertFromList = this.insertFromList.bind(this);
        this.notify = this.notify.bind(this);
        this.remove = this.remove.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onSelectTag = this.onSelectTag.bind(this);

        this.state = {
            tags: props.value || [],
            input: '',
            showSuggestions: false
        };
    }

    componentWillReceiveProps(props)
    {
        this.setState({tags: props.value || []});
    }

    componentDidUpdate()
    {
        if (this.upd && this.inputCtrl)
        {
            this.upd = false;
            this.inputCtrl.focus();
        }
    }

    onInput(e)
    {
        this.setState({
            input: e.target.value
        });
    }

    onKeyDown(e)
    {
        if (e.keyCode == 13)
        {
            let tags = this.state.tags || [];
            let input = this.state.input.trim();
            if (input && tags.indexOf(input) < 0)
            {
                tags = [...tags, input]; //...operator makes copy of original array, required to detect changes later
                this.setState({
                    input: '',
                    tags: tags
                });
                this.upd = true;
                this.notify(tags);
            }
        }
    }

    remove(e)
    {
        let displaymode = this.props.displaymode || 'form';
        let tags = this.state.tags || [];
        if (displaymode == 'filter')
        {
            tags = tags.filter((t) => {
                return t != e.target.parentElement.dataset.content && t.indexOf(e.target.parentElement.dataset.content + '/') !== 0;
            });
        } else {
            tags = tags.filter((t) => {
                return t != e.target.parentElement.dataset.content;
            });
        }
        this.setState({
            tags: tags
        });
        this.upd = true;
        this.notify(tags);
    }

    insertFromList(e)
    {
        let tags = this.state.tags || [];
        if (e.target.dataset.content && tags.indexOf(e.target.dataset.content) < 0)
        {
            tags = [...tags, e.target.dataset.content]; //...operator makes copy of original array, required to detect changes later
            this.setState({
                input: '',
                tags: tags
            });
            this.upd = true;
            this.notify(tags);
        }
    }

    onSelectTag(e)
    {
        let tags = this.state.tags || [];
        if (e.target.value && tags.indexOf(e.target.value) < 0)
        {
            tags = [...tags, e.target.value]; //...operator makes copy of original array, required to detect changes later
            this.setState({
                tags: tags
            });
            this.upd = true;
            this.notify(tags);
        }
    }

    notify(tags)
    {
        if (typeof this.props.onInput == 'function')
        {
            this.props.onInput({
                type: 'input',
                target: {
                    dataset: {
                        field: this.props.field
                    },
                    value: tags
                }
            });
        }
    }

    async onTagClicked(tag)
    {
        let choice = await MessageBox.show({
            title: 'Filter bereit',
            text: 'Sie möchten nach dem Stichwort "' + tag + '" filtern.',
            actions: [{title: "Ergebnisse anzeigen", default: true}, {title: I.Cancel, cancel: true}]
        });
        if (choice === 0)
        {
            AppState.set('item', undefined);
            AppState.set('filter', [tag]);
            AppState.set('search', '');
            AppState.set('folder', undefined);
            AppState.set('collection', undefined);
        }
    }

    render()
    {
        if (this.state.tags.length == 0 && this.props.readonly) return;
        
        let tags = this.state.tags.map((tag) =>
        {
            let action = this.props.readonly ? () => this.onTagClicked(tag) : undefined;
            return <div class="tag" data-content={tag} onClick={action}><div class="content">{tag}</div><div class="remove" onClick={this.remove}></div></div>;
        });
        
        let suggestions = TcrTags.getSuggestions(this.state.tags, this.state.input).map((s)=>
        {
            return <div class="suggestion" data-content={s} onClick={this.insertFromList}>{s}</div>;
        });
        let input = [
            <input type="text" key="sameoldinput" ref={dom => this.inputCtrl = dom} value={this.state.input} placeholder={tags.length ? '...' : this.props.placeholder} onInput={this.onInput} onKeyDown={this.onKeyDown} />
        ];
        return (
            <div class="tcr-tag-input" data-readonly={this.props.readonly} >
                {tags}
                <div class="rest" tabindex="-1">
                    {input}
                </div>
                <div class="suggestions" data-hide={!this.state.input}>
                    {suggestions}
                </div>
            </div>
        );
    }
}

export { TcrTagInput };
